module.exports = __webpack_public_path__ + "static/media/instructivo2.93ecb5f4.png";